import * as yup from "yup";
import BaseForm from "../../../../../../shared/components/form/BaseForm";
import FormInput from "../../../../../../shared/components/input/FormInput";
import { useTranslation } from "react-i18next";
import FormSwitch from "../../../../../../shared/components/switch/FormSwitch";

const UpdateClientForm = ({ client, onSubmitHandler }) => {
  const { t } = useTranslation();

  const validationSchema = yup.object({
    code: yup.string().required(t("clients.updateForm.fields.code.required")),
    name: yup.string().required(t("clients.updateForm.fields.name.required")),
  });

  const defaultValues = {
    code: client?.code,
    name: client?.name,
    ga4PropertyId: client?.ga4PropertyId,
    enabled: client?.enabled,
  };

  return (
    <BaseForm
      validationSchema={validationSchema}
      defaultValues={defaultValues}
      onSubmitHandler={onSubmitHandler}
      isCreationForm={false}
    >
      <div className="flex flex-row justify-between gap-x-4">
        <div className="w-1/2">
          <FormInput
            name="code"
            label={t("clients.updateForm.fields.code.label")}
            required
          />
        </div>
        <div className="w-1/2">
          <FormInput
            name="name"
            label={t("clients.updateForm.fields.name.label")}
            required
          />
        </div>
      </div>
      <div className="flex flex-row">
        <div className="w-full">
          <FormInput
            name="ga4PropertyId"
            label={t("clients.updateForm.fields.ga4PropertyId.label")}
          />
        </div>
      </div>
      <FormSwitch
        name="enabled"
        label={t("clients.updateForm.fields.enabled.label")}
      />
    </BaseForm>
  );
};

export default UpdateClientForm;
